import { JsonPipe, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-system-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    imports: [TranslateModule, NgIf, JsonPipe]
})
export class SystemErrorComponent {
  debug: any;

  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      if (params['debug']) {
        this.debug = JSON.parse(atob(params['debug']));

      }

    });
  }

}
